import {ITheme} from 'contexts/ThemeContext';
import {Platform, StyleSheet, useWindowDimensions} from 'react-native';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return StyleSheet.create({
    buttonStyle: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 6,
      paddingVertical: 6,
      width: 68,
      height: 35,
      backgroundColor: colors.cornflowerBlue,
      borderRadius: 8,
    },
    imageStyle: {
      marginRight: 4.5,
      width: 15.17,
      height: 17.67,
      tintColor: colors.white,
    },
    buttonLabelStyle: {
      fontSize: 14,
      lineHeight: 23,
      color: colors.white,
      ...typography.interMedium,
    },
  });
};
